import { useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/pro-solid-svg-icons/faEye'
import { useTranslation } from 'react-i18next'
import { Tooltip } from 'antd'
import { ILearningProgram } from 'interfaces/roles'
import { Wrapper } from './styled'
import Detail from './detail'

interface IProps {
  learningProgram: ILearningProgram
}

const Courses = ({ learningProgram }: IProps) => {
  const { t } = useTranslation()
  const prefix =
    'configuration.rolesAndPermissions.form.sections.accessToLearningPrograms.learningPrograms.table.headers.courses'
  const [showDetail, setShowDetail] = useState(false)

  return (
    <>
      <Tooltip
        getPopupContainer={() =>
          document.getElementById('lmsPage') as HTMLElement
        }
        title={t(`${prefix}.tooltip`)}
      >
        <Wrapper onClick={() => setShowDetail(true)}>
          {learningProgram.courses}{' '}
          {learningProgram.courses === 1
            ? t(`${prefix}.value.singular`)
            : t(`${prefix}.value.plural`)}
          <FontAwesomeIcon icon={faEye} />
        </Wrapper>
      </Tooltip>
      {showDetail && (
        <Detail
          learningProgram={learningProgram}
          close={() => setShowDetail(false)}
        />
      )}
    </>
  )
}

export default Courses
